/**
 * @module Utilities/Request
 * @desc Request helper funtions
 */
import { getFetchParams, handleError, handleSuccess } from './helpers';
import { resolversMapper } from './resolvers';

import type { RequestAction } from './request.d';

/**
 * Fetch data returning a Promise
 */
export function request<T>(action: RequestAction): Promise<T> {
  if (!action) {
    throw new Error('The action parameter is required');
  }

  const { params, url } = getFetchParams(action);

  return fetch(url, params).then(async (response) => {
    const resolver = resolversMapper[response.status];

    if (resolver) {
      return resolver({ params, response, url });
    }

    if (response.status > 299) {
      return handleError(response);
    }

    return handleSuccess(response);
  });
}
